import React, { useState } from 'react';
import './ContactPage.css'; // Make sure this CSS file is correctly linked and styled

// Assuming you are using a library like react-icons or fontawesome for icons:
// import { FaHome } from 'react-icons/fa'; // Example for home icon

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [formStatus, setFormStatus] = useState({
    loading: false,
    error: '',
    success: '',
  });

  // --- Web3Forms Configuration ---
  const WEB3FORMS_ACCESS_KEY = "8d98ec0a-f9a7-44bb-bbd2-975d7f440d32";
  const WEB3FORMS_ACTION_URL = "https://api.web3forms.com/submit";
  const WEB3FORMS_FROM_NAME = "ABP Airbags Website";
  // const WEB3FORMS_REDIRECT_URL = "https://yourdomain.com/thankyou.html";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ loading: true, error: '', success: '' });

    const payload = {
      ...formData,
      access_key: WEB3FORMS_ACCESS_KEY,
      from_name: WEB3FORMS_FROM_NAME,
      botcheck: '',
      subject: `New Contact from ${WEB3FORMS_FROM_NAME}: ${formData.subject}`
    };

    try {
      const response = await fetch(WEB3FORMS_ACTION_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        setFormStatus({ loading: false, error: '', success: result.message || 'Your message has been sent successfully. Thank you!' });
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        console.error("Web3Forms API Error:", result);
        setFormStatus({ loading: false, error: result.message || 'Failed to send message. Please try again.', success: '' });
      }
    } catch (error) {
      console.error("Form Submission Error:", error);
      setFormStatus({ loading: false, error: 'An unexpected error occurred. Please check the console.', success: '' });
    }
  };

  const contactLocations = [
    {
      title: "Head Office",
      tags: "#EuropeanHeadquarters #Sales",
      address: "1103 Budapest, Gyömrői út 115 Hungary",
      generalEmail: "info@abpairbag.eu",
      salesEmail: "sales@abpairbag.eu",
      phone: "+36 (70) 369 3425",
      website: "www.abpairbag.eu",
      icon: "bx bx-building",
    },
    {
      title: "Hungary Warehouse",
      tags: "#Distribution #Operations",
      address: "Lőrinci út 154 \"E\" Building 2220 Vecsés Hungary",
      operationEmail: "operation@abpairbag.eu",
      phone: "+36 (70) 433 0900",
      website: "www.abpairbag.eu",
      icon: "bx bx-store-alt",
    }
  ];

  return (
    <main id="main" className="contact-page-main">
      <section id="breadcrumbs" className="breadcrumbs">
        <div className="container">
          <ol>
            <li><a href="/"> {/* <FaHome /> */} Home</a></li>
            <li>Contact</li>
          </ol>
        </div>
      </section>

      {/* ======= Map Section ======= */}
      <div id="basic-map" className="contact-map-section">
        <div id="map_canvas">
          <iframe
            src="https://www.google.com/maps/d/embed?mid=12kwL7KaCWBTkjfzV6XRAUOwjfvmrrzzR&ehbc=2E312F"
            style={{ marginTop: "-20px", zIndex: 0, border: 0 }}
            width="100%"
            height="250"
            allowFullScreen=""
            loading="lazy"
            title="Our Locations"
          ></iframe>
        </div>
      </div>

      <section id="contact" className="contact-section">
        <div className="container contact-content-wrapper">
          <div className="row">
            <div className="col-lg-5 contact-info-column">
              <div className="section-title-contact">
                <h2>Get In Touch</h2>
                <p>We'd love to hear from you. Reach out with any questions or inquiries.</p>
              </div>
              {/* *** MODIFIED: Added info-box-content div wrapper around h3 and p *** */}
              <div className="info-box">
                <i className="bx bx-map"></i>
                <div className="info-box-content">
                  <h3>Location</h3>
                  <p>1103 Budapest,<br />Gyömrői út 115.</p>
                </div>
              </div>
              <div className="info-box">
                <i className="bx bx-envelope"></i>
                <div className="info-box-content">
                  <h3>Email</h3>
                  <p><a href="mailto:info@abpairbag.eu">info@abpairbag.eu</a></p>
                </div>
              </div>
              <div className="info-box">
                <i className="bx bx-phone-call"></i>
                <div className="info-box-content">
                  <h3>Phone</h3>
                  <p><a href="tel:+36703693425">+36 70 369 3425</a></p>
                </div>
              </div>
            </div>

            <div className="col-lg-7 contact-form-column">
              <div className="section-title-contact form-title">
                <h2>Contact Form</h2>
              </div>
              <div className="php-email-form">
                <div className="form-row">
                  <div className="col form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      id="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      minLength="4"
                    />
                  </div>
                  <div className="col form-group">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    id="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    minLength="4"
                  />
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="6"
                    placeholder="Your Message..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <div className="form-feedback mb-3">
                  {formStatus.loading && <div className="loading form-status" style={{display: 'block'}}>Sending your message...</div>}
                  {formStatus.error && <div className="error-message form-status" style={{display: 'block'}}>{formStatus.error}</div>}
                  {formStatus.success && <div className="sent-message form-status" style={{display: 'block'}}>{formStatus.success}</div>}
                </div>
                <div className="text-center">
                  <button type="submit" className="submit-btn" disabled={formStatus.loading} onClick={handleSubmit}>
                    {formStatus.loading ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="partner-contacts-section" style={{ backgroundImage: "url('assets/img/earth.jpg')" }}>
        <div className="container">
          <div className="section-title center">
            <h2>Contacts</h2>
            <div className="title-bar"></div>
          </div>

          {contactLocations.map((location, index) => (
            <div className="partner-contact-info" key={index}>
              <div className={index === 0 ? "contact-bg" : ""}>
                <div className="contact-content">
                  <div className="row align-items-stretch">
                    <div className="col-lg-3 d-flex">
                      <div className="info-box main">
                        {location.icon && <i className={`${location.icon} location-title-icon`}></i>}
                        <h3>{location.title}</h3>
                        {location.tags && <p className="tags">{location.tags}</p>}
                      </div>
                    </div>
                    <div className="col-lg-3 d-flex">
                      <div className="info-box">
                        <i className="bx bx-map"></i>
                        <p>{location.address}</p>
                      </div>
                    </div>
                    <div className="col-lg-2 d-flex">
                      <div className="info-box">
                        <i className="bx bx-envelope"></i>
                        <div>
                          {location.generalEmail && (
                            <p><a href={`mailto:${location.generalEmail}`} style={{ wordWrap: 'break-word' }}>General: {location.generalEmail}</a></p>
                          )}
                          {location.salesEmail && (
                            <p><a href={`mailto:${location.salesEmail}`} style={{ wordWrap: 'break-word' }}>Sales: {location.salesEmail}</a></p>
                          )}
                          {location.operationEmail && (
                            <p><a href={`mailto:${location.operationEmail}`} style={{ wordWrap: 'break-word' }}>Operations: {location.operationEmail}</a></p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 d-flex">
                      <div className="info-box">
                        <i className="bx bx-phone-call"></i>
                        <p><a href={`tel:${location.phone.replace(/\s|-|\(|\)/g, '')}`}>Sales: {location.phone}</a></p>
                      </div>
                    </div>
                    <div className="col-lg-2 d-flex">
                      <div className="info-box">
                        <i className="bx bx-world"></i>
                        <p><a href={`https://${location.website}`} target="_blank" rel="noopener noreferrer" style={{ wordWrap: 'break-word' }}>{location.website}</a></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default ContactPage;